export const topMenus = [
  { key: 'energyQuery', title: '能耗查询', path: '/energy-query', hidden: true },
  { key: 'energyFlow', title: '能流分析', path: '/energy-flow' },
  { key: 'carbonAccounting', title: '碳排放核算', path: '/carbon-accounting' },
  { key: 'carbonAsset', title: '碳资产管理', path: '/carbon-asset' },
  { key: 'carbonFootprint', title: '碳足迹核算', path: '/carbon-footprint' }
]

export const visibleTopMenus = topMenus.filter(item => !item.hidden)

export const sidebarMenus = {
  energyQuery: [
    { title: '数据概览', path: '/energy-query/overview', icon: 'el-icon-data-line' },
    { title: '分类历史数据', path: '/energy-query/history', icon: 'el-icon-document' },
    { title: '监测实时数据', path: '/energy-query/realtime', icon: 'el-icon-monitor' }
  ],
  energyFlow: [
    { title: '能流分析', path: '/energy-flow/analysis', icon: 'el-icon-share' },
    { title: '平衡校验', path: '/energy-flow/balance', icon: 'el-icon-finished' }
  ],
  carbonAccounting: [
    { title: '首页', path: '/carbon-accounting/home', icon: 'el-icon-s-home' },
    { title: '盘查边界管理', path: '/carbon-accounting/boundary', icon: 'el-icon-map-location' },
    { title: '碳排放报告管理', path: '/carbon-accounting/report', icon: 'el-icon-document' },
    { title: '报告评价', path: '/carbon-accounting/evaluation', icon: 'el-icon-star-off' },
    { title: '基础数据库', path: '/carbon-accounting/database', icon: 'el-icon-coin' }
  ],
  carbonAsset: [
    { title: '市场行情', path: '/carbon-asset/market', icon: 'el-icon-data-analysis' },
    { title: '资产登记', path: '/carbon-asset/register', icon: 'el-icon-edit-outline' },
    { title: '资产统计分析', path: '/carbon-asset/statistics', icon: 'el-icon-pie-chart' },
    { title: '配额测算', path: '/carbon-asset/calculation', icon: 'el-icon-s-data' },
    { title: '配额预警', path: '/carbon-asset/quota-warning', icon: 'el-icon-warning-outline' }
  ],
  carbonFootprint: [
    { title: '首页', path: '/carbon-footprint/home', icon: 'el-icon-s-home' },
    { title: '模型管理', path: '/carbon-footprint/model', icon: 'el-icon-s-operation' },
    { title: '足迹核算', path: '/carbon-footprint/accounting', icon: 'el-icon-s-check' },
    { title: '报告评价', path: '/carbon-footprint/evaluation', icon: 'el-icon-star-off' },
    { title: '碳标签', path: '/carbon-footprint/label', icon: 'el-icon-price-tag' },
    { title: '背景数据库', path: '/carbon-footprint/database', icon: 'el-icon-coin' }
  ]
}

export function getModuleByPath(path) {
  const menu = topMenus.find(item => path.startsWith(item.path))
  return menu ? menu.key : visibleTopMenus[0].key
}

export function getDefaultRoute() {
  const firstMenu = visibleTopMenus[0]
  const firstChild = sidebarMenus[firstMenu.key] && sidebarMenus[firstMenu.key][0]
  return firstChild ? firstChild.path : firstMenu.path
}
